import styled from 'styled-components'

const StyledAccountBilling = styled.div`
  h1 {
    font-family: ${({ theme }) => theme.fonts.lexend};
    color: ${({ theme }) => theme.colors.gray[700]};
    font-size: 32px;
    font-weight: 400;
    line-height: 45px;
    text-align: center;
    margin: 30px 0;
  }

  button {
    cursor: pointer;
  }

  .billing-divider {
    background-color: ${({ theme }) => theme.colors.gray[200]};
    height: 1px;
    border: none;
    padding: 0;
  }

  .modal {
    padding: 15px 10px;
    border-radius: 10px;

    .modal-title {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      color: ${({ theme }) => theme.colors.green[500]};
      line-height: 24px;
      font-weight: 700;
    }

    .modal-text {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      font-weight: 400;
    }

    a {
      font-family: ${({ theme }) => theme.fonts.nunito};
      font-size: 16px;
      font-weight: 400;
      text-decoration: underline;
    }

    .modal-footer {
      justify-content: center;
    }
  }
`

export default StyledAccountBilling
